import Helper from "@ember/component/helper";
import { service } from "@ember/service";
export default class HtmlClass extends Helper {
  static #_ = (() => dt7948.g(this.prototype, "elementClasses", [service]))();
  #elementClasses = (() => (dt7948.i(this, "elementClasses"), void 0))();
  compute(_ref) {
    let [...classes] = _ref;
    this.elementClasses.registerClasses(this, document.documentElement, classes.flatMap(c => c?.split(" ")).filter(Boolean));
  }
}